//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "AccountPreferences",
  mixins: [validationMixin],
  validations: {
    tutorial: {
      required
    }
  },
  props: {
    accountPreferences: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      tutorial: this.accountPreferences.tutorial,
      includeExisting: this.accountPreferences.includeExisting
    };
  },
  computed: {
    isFormValid() {
      return !this.$v.$invalid;
    }
  },
  watch: {
    isFormValid: {
      handler(valid) {
        this.$emit("allow-save", valid);
      }
    }
  },
  methods: {
    handleInitialSubmit() {
      this.$emit("initial-submit");
    },
    handleSubmit() {
      if (this.isFormValid) {
        this.$emit("submit", {
          tutorial: this.tutorial,
          includeExisting: this.includeExisting
        });
      }
    },
    handleFormChange() {
      this.$emit("form-change", "accountPreferences");
      this.$emit("allow-save", true);
    }
  }
});